import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wallet03 = function Wallet03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16.5 14h.01M3 5v14c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2V9c0-1.1046-.8954-2-2-2H5c-1.1046 0-2-.8954-2-2m0 0c0-1.1046.8954-2 2-2h12m0 11a.5.5 0 1 1-1.0001-.0001A.5.5 0 0 1 17 14"
    })
  }));
};
export default Wallet03;